import { Container } from "react-bootstrap";

export default function Restriction() {
  return (
    <>
      <Container fluid>
        Restricted Page
      </Container>
    </>
  );
}
